export default "/images/6cbfbe9efefa9d61b227dc837c615f79.avif";